export enum CapacityGroupsEnum {
  ADVERTISER = "ADVERTISER",
  OFFER = "OFFER",
  WEBMASTER = "WEBMASTER",
  AGENT = "AGENT",
  EXTERNAL_WEBMASTER = "EXTERNAL_WEBMASTER",
  SUB_WEBMASTER = "SUB_WEBMASTER"
}